// Backdrop.js
import React from "react";

const Backdrop = ({ isVisible, onClick }) => {
  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-40"
      onClick={onClick}
    ></div>
  );
};

export default Backdrop;
